<template>

  <div class="request-call-panel" v-show="showRC">
    <vs-switch class="blur-panel" v-model="blur" @change="change" color="#ffffff"></vs-switch>
    <div class="blur-panel-label">Blur</div>
    <div class="circleBox">
      <div class="circle1"></div>
      <div class="circle2"></div>
      <div class="circle3"></div>
      <div class="circle4"></div>
      <div class="circle5">
        <img :src="wrapAvatar(info.avatar)" alt="" class="avatar" :onerror="errorAvatar">
      </div>
    </div>
    <div class="anchor-name" v-text="info.nickName"></div>
    <div class="timer" v-text="leftTime"></div>
    <div class="tips-panel">
      <div class="tips-icon"></div>
      <div class="tips" v-text="curTips"></div>
    </div>
    <div class="end-call" @click="cancelRequest(1)"></div>
    <!--    <audio :src="ring" loop="loop" preload="auto" id="ring-ele" muted="muted"></audio>-->
  </div>

</template>

<script>
  import icondefaulthead from '../../../assets/imgs/icon_default_head.png'
  import {
    debounce,
    getMediumLink,
    hideDialog,
    isnull,
    localGet,
    localGetBoolean,
    localSave,
    showDeviceError,
    showDialog,
    Toast
  } from '../../../utils/tools'
  import global from '../../../config/global'
  import ring from '../../../../static/attach/sd_call.mp3'
  import EventBusConstant from '../../../push/const/EventBusConstant'
  import TipsUtils from '../../../utils/TipsUtils'
  import accountApi from '../../../api/account-api'
  import roomApi from '../../../api/room-api'
  import PermissionCheck from '../../../utils/PermissionUtils'
  import router from '../../../router'

  export default {
    name: 'requestcall',
    props: {
      avatar: {
        type: String,
        default: icondefaulthead
      },
      nickName: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        inReqCall:false,
        localTrack: null,
        callSuc: false,
        toRoom: false,
        successCallback: null,
        failCallback: null,
        info: {},
        showRC: false,
        ring,
        errorAvatar: 'this.src="' + icondefaulthead + '"',
        blur: false,
        curTips: '',
        callTipsIndex: 0,
        callTips: [
          'Recharge now to meet more amazing girls!',
          'Follow her to not miss her any precious moment.',
          'Don\'t forget to give her a "like" after the call.',
          'You won\'t regret to call her.',
          'She will be super happy if you send her gifts.',
          'Have a good time!',
        ],
        tipsChangeTimer: null,
        leftTime: '00:00',
        totalSeconds: 0,
        cancelTimer: null,
        audioEle: null,
      }
    },
    created() {
      // this.sound=new Howl({
      //   src:[this.ring],
      //   html5:true,
      //   loop:true,
      //   preload:true,
      // })

    },
    mounted() {
      // HWLPLayer.addAudiAddr(ring,true)
      let curObj = this
      // audioContext.loadAudioFile(ring)
      this.$EventBus.$on(EventBusConstant.EVENT_USER_ENTER_ROOM, (code, data) => {
        let enterPrivateChatData = data
        enterPrivateChatData.callType = curObj.$route.path == '/conv/chat' ? 4 : 0
        enterPrivateChatData.anchorDisplayAccountId = curObj.info.displayAccountId
        enterPrivateChatData.anchorAvatar = curObj.info.avatar
        global.setCoins(enterPrivateChatData.leftDiamond - enterPrivateChatData.initialPrice)
        curObj.toCallRoom(enterPrivateChatData)
      })
      this.$EventBus.$on(EventBusConstant.EVENT_ANCHOR_REFUSE_CALL, (diamond, accId) => {
        Toast.info('Call Refused', curObj)
        curObj.cancelRequest()
      })
      this.$EventBus.$on(EventBusConstant.EVENT_USER_CALL, (code, accId) => {
        curObj.callSuc = true
        if (code == -25) {
          Toast.error('Coins not enough', curObj)
          curObj.hideRequestCall()
        } else if (code == 0) {
          hideDialog(curObj)
          curObj.showRequestCall()
          curObj.clearCallResultTimer()
          // curObj.$EventBus.$emit(EventBusConstant.EVENT_CLEAR_CALL_RESULT_TIMER)
        } else {
          hideDialog(curObj)
          Toast.error(TipsUtils.getErrorTips(code), curObj)
        }
      })

    },
    methods: {
      wrapAvatar(src) {
        return getMediumLink(src)
      },
      requestCall:function(anchorId, successCallback, failCallback) {
        if (this.inReqCall)
          return;
        this.successCallback = successCallback
        this.failCallback = failCallback
        let curObj = this
        if (!curObj.$root.sseClient || !curObj.$root.sseClient.connected) {
          Toast.error('Please  check your network.', curObj)
          return
        }
        if (isnull(anchorId)) {
          failCallback && failCallback()
          return
        }
        this.inReqCall = true
        accountApi.getAnchorInfo(anchorId, function (data, page) {
          page.info = data
          if ([0, 1].indexOf(data.lineStatus) != -1) {
            // if (!global.checkCoinsEnough(page.info.callFee)) {
            //   page.inReqCall = false
            //   Toast.error('Coins not enough', page)
            //   return
            // }
            PermissionCheck.checkAudioAndCameraPermission(function (page) {
              page.execRequest()
            }, function (page) {
              // page.execRequest()
              page.inReqCall=false
              page.$EventBus.$emit(global.SHOW_DEVICE_ERROR)
            }, page)
          } else {
            Toast.error('The host is busy', page)
            page.inReqCall=false
          }
        }, function (code, msg, page) {
          Toast.error(TipsUtils.getErrorTips(code), page)
          page.inReqCall=false
        }, curObj, false, false)
      },
      change() {
        localSave(global.SELF_BLUE_KEY, this.blur)
      },
      cancelRequest(manual) {
        // this.$emit('cancelrequestcall', manual)
        this.hideRequestCall()
        if (!manual) {
          this.toRecommend()
        }
      },
      showTips() {
        let target = this
        target.curTips = this.callTips[this.callTipsIndex++ % 6]
        if (!target.tipsChangeTimer) {
          target.tipsChangeTimer = setInterval(function () {
            target.showTips()
          }, 5000)
        }
      },
      clearTips() {
        if (this.tipsChangeTimer) {
          clearInterval(this.tipsChangeTimer)
          this.tipsChangeTimer = null
        }
      },
      formatMinutes(seconds) {
        if (seconds < 0) {
          seconds = 0
        }
        let minute = Math.floor(seconds / 60)
        let leftSeconds = seconds % 60
        let label = (minute < 10 ? '0' + minute : minute) + ':' + (leftSeconds < 10 ? '0' + leftSeconds : leftSeconds)
        return label
      },
      startCancelTimer() {
        if (!this.cancelTimer) {
          let target = this
          this.cancelTimer = setInterval(function () {
            target.leftTime = target.formatMinutes(++target.totalSeconds)
            if (target.totalSeconds == 45) {
              target.cancelRequest()
            }
          }, 1000)
        }
      },
      clearCancelTimer() {
        if (this.cancelTimer) {
          clearInterval(this.cancelTimer)
          this.cancelTimer = null
        }
      },
      async playRing() {

        // if (!this.audioEle) {
        //   this.audioEle = document.getElementById('ring-ele')
        // }
        // if (this.audioEle) {
        //   this.audioEle.play()
        // }
        if (!this.localTrack) {
          await this.initMps()
        }
        this.localTrack.play()
      },
      pauseRing() {
        // if (this.audioEle && !this.audioEle.paused) {
        //   this.audioEle.pause()
        // }
        this.releaseLocalTrack()
      },
      execRequest() {
        showDialog(this)
        let target=this
        if (!this.callSuc) {
          this.callResultTimer = setTimeout(function () {
            if (!target.toRoom) {
              target.doStopCall()
              target.info.lineStatus = 3
              target.failCallback && this.failCallback(-3)
              hideDialog(this)
            }
          }, 30 * 1000)
        }
        roomApi.callAnchor(this.info.accountId, function (data, page) {
          hideDialog(page)
          page.inReqCall=false
          if (data > 0) {
            page.callSuc = true
            page.showRequestCall()
            page.clearCallResultTimer()
            // curObj.$EventBus.$emit(EventBusConstant.EVENT_CLEAR_CALL_RESULT_TIMER)
          } else {
            Toast.error(TipsUtils.getErrorTips(data), page)
          }
        }, function (code, msg, page) {
          page.inReqCall=false
          hideDialog(page)
          Toast.error(TipsUtils.getErrorTips(code), page)
          if (code == -25) {
            page.hideRequestCall()
          }
        }, this)
      },
      doStopCall() {
        this.clearCallResultTimer()
        if (!isnull(this.info) && !isnull(this.info.accountId))
          roomApi.stopCallAnchor(this.info.accountId, function (data, page) {

          }, function (code, msg, page) {

          }, this)


      },
      clearCallResultTimer() {
        if (this.callResultTimer) {
          clearTimeout(this.callResultTimer)
          this.callResultTimer = null
        }

      },
      toRecommend() {
        localSave(global.key.TO_RECOMMEND, true)
        router.push({
          path: '/svc/aal',
          // replace:true
        })
      },
      toCallRoom(enterPrivateData) {
        this.toRoom = true
        this.cancelRequest(1)
        showDialog(this)
        router.togo({
          name: 'CallRoom',
          params: {
            acc: this.info.accountId || '',
            name: this.info.anchorName || '',
            price: this.info.callFee || '',
            enterPrivateData: enterPrivateData || ''
          }
        })
      },
      hideRequestCall() {
        this.showRC = false
        if (!this.toRoom) {
          this.doStopCall()
        }

      },
      showRequestCall() {
        this.showRC = true
      },
      async initMps() {
        if (this.localTrack == null) {
          this.localTrack = await AgoraRTC.createBufferSourceAudioTrack({
            source: '/static/attach/sd_call.mp3'
          })
          console.log(this.localTrack)
          this.localTrack.startProcessAudioBuffer({loop: true})
        }
      },
      releaseLocalTrack() {
        if (this.localTrack) {
          this.localTrack.stop()
          this.localTrack.stopProcessAudioBuffer()
          this.localTrack = null
        }
      },

    },
    watch: {
      showRC(n, o) {
        if (n) {
          this.toRoom = false
          this.blur = localGetBoolean(global.SELF_BLUE_KEY, false)
          this.showTips()
          this.startCancelTimer()
          this.playRing()
          document.body.addEventListener('touchmove', this.disableTouch
            , true)
        } else {
          document.body.removeEventListener('touchmove', this.disableTouch)
          window.removeEventListener('touchstart', this.dealTouchToPlay)
          this.clearTips()
          this.clearCancelTimer()
          this.releaseLocalTrack()
          this.totalSeconds = 0
          this.leftTime = '00:00'
        }
      }
    },
    beforeDestroy() {
      this.releaseLocalTrack()
      this.clearTips()
      this.clearCancelTimer()
      this.pauseRing()
      this.$EventBus.$off(EventBusConstant.EVENT_USER_ENTER_ROOM)
      this.$EventBus.$off(EventBusConstant.EVENT_ANCHOR_REFUSE_CALL)
      this.$EventBus.$off(EventBusConstant.EVENT_USER_CALL)
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";


  .request-call-panel {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: url(../../../assets/imgs/pending-call-bg.png) no-repeat;
    background-size: cover;
    font-family: Gilroy-Medium;
    background-color: #fff;

    .blur-panel {
      .w(114);
      .h(56);
      .mt(46);
      float: right;
      .mr(30);
    }

    .blur-panel-label {
      .fs(28);
      font-weight: 500;
      color: #FFFFFF;
      .lh(33);
      vertical-align: center;
      .mr(20);
      .mt(57);
      float: right;
    }

    .anchor-name {
      .ml(30);
      text-align: center;
      .fs(48);
      font-weight: bold;
      color: #FFFFFF;
      .lh(48);
      .mt(649);
    }

    .timer {
      text-align: center;
      .fs(36);
      font-weight: bold;
      color: #FFFFFF;
      opacity: .7;
      .lh(48);
      .ml(30);
      .mt(7);
    }

    .tips-panel {
      left: 50%;
      transform: translateX(-50%);
      .w(690);
      .h(202);
      background: url(../../../assets/imgs/rcall-tips-panel-bg.png) no-repeat;
      background-size: contain;
      position: fixed;
      .bottom(271);

      .tips-icon {
        .w(40);
        .h(40);
        background: url(../../../assets/imgs/rcall-tips-icon.png) no-repeat;
        background-size: contain;
        position: absolute;
        .ml(27);
        .mt(36);
      }

      .tips-icon::after {
        content: 'Tips';
        .fs(36);
        font-weight: bold;
        color: #FFF0BD;
        .lh(36);
        vertical-align: center;
        .ml(52);
        display: inline-block;
      }

      .tips {
        .w(636);
        .ml(27);
        .fs(28);
        .mt(100);
        position: absolute;
        font-weight: 500;
        color: #FFFFFF;
        .lh(33);
        opacity: .8;
        text-align: left;
      }
    }

    .end-call {
      .w(126);
      .h(126);
      background: url(../../../assets/imgs/rcall-end.png) no-repeat;
      background-size: contain;
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      .bottom(99);
    }

    .circleBox {
      .w(254);
      .h(254);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      .mt(211);

    }

    @media (max-height: 620px) {
      .blur-panel {
        .mt(26);
      }

      .blur-panel-label {
        .mt(37);
      }

      .circleBox {
        .mt(130)
      }

      .anchor-name {
        .mt(500);
      }

    }

    @media (max-height: 550px) {

      .tips-panel {
        .bottom(180);
      }

      .end-call {
        .bottom(40)
      }
    }

    .circle1, .circle2, .circle3, .circle4, .circle5 {
      .w(254);
      .h(254);
      border-radius: 50%;
      position: absolute;

    }

    .circle5 {
      .w(254);
      .h(254);
    }

    .circle5 > img {
      .w(250);
      .h(250);
      .b-radius(127);
      .border(4, solid, #ff0e74);
      object-fit: cover;

    }

    .circle1 {
      animation: myfirst 4s linear 0s infinite;
      background: rgba(255, 255, 255, 0.4);
      -moz-animation: myfirst 4s linear 0s infinite; /* Firefox */
      -webkit-animation: myfirst 4s linear 0s infinite; /* Safari 和 Chrome */
      -o-animation: myfirst 4s linear 0s infinite; /* Opera */
    }

    .circle2 {
      animation: myfirst 4s linear 1s infinite;
      background: rgba(255, 255, 255, 0.3);
      -moz-animation: myfirst 4s linear 1s infinite; /* Firefox */
      -webkit-animation: myfirst 4s linear 1s infinite; /* Safari 和 Chrome */
      -o-animation: myfirst 4s linear 1s infinite; /* Opera */

    }

    .circle3 {
      animation: myfirst 4s linear 2s infinite;
      background: rgba(255, 255, 255, 0.1);
      -moz-animation: myfirst 4s linear 2s infinite; /* Firefox */
      -webkit-animation: myfirst 4s linear 2s infinite; /* Safari 和 Chrome */
      -o-animation: myfirst 4s linear 2s infinite; /* Opera */

    }

    .circle4 {
      animation: myfirst 4s linear 3s infinite;
      background: rgba(255, 255, 255, 0.04);
      -moz-animation: myfirst 4s linear 3s infinite; /* Firefox */
      -webkit-animation: myfirst 4s linear 3s infinite; /* Safari 和 Chrome */
      -o-animation: myfirst 4s linear 3s infinite; /* Opera */

    }

    @keyframes myfirst {
      0% {
        -webkit-transform: scale(1);

        transform: scale(1);
        opacity: 1;
      }

      10% {
        -webkit-transform: scale(1.119);
        transform: scale(1.119);
        opacity: 0.9;
      }

      20% {
        -webkit-transform: scale(1.238);
        transform: scale(1.238);
        opacity: 0.8;
      }

      30% {
        -webkit-transform: scale(1.357);
        transform: scale(1.357);
        opacity: 0.7;
      }

      40% {
        -webkit-transform: scale(1.476);
        transform: scale(1.5);
        opacity: 0.6;
      }

      50% {
        -webkit-transform: scale(1.595);
        transform: scale(1.595);
        opacity: 0.5;
      }

      60% {
        -webkit-transform: scale(1.714);
        transform: scale(1.714);
        opacity: 0.4;
      }

      70% {
        -webkit-transform: scale(1.833);
        transform: scale(1.833);
        opacity: 0.3;
      }

      80% {
        -webkit-transform: scale(1.952);
        transform: scale(1.952);
        opacity: 0.2;
      }

      90% {
        -webkit-transform: scale(2.071);
        transform: scale(2.071);
        opacity: 0.1;
      }

      100% {
        -webkit-transform: scale(2.19);
        transform: scale(2.19);
        opacity: 0;

      }

    }

    .avatar {
      object-fit: cover;
    }
  }

  /deep/ .vs-switch {
    .w(114) !important;
    .h(56) !important;
    background: #FFFFFF !important;

    &__circle {
      .w(48);
      .h(48);
      .b-radius(24);
      position: absolute;
      .top(4);
      .left(4);
      background: #afafaf !important;
    }

    &__input:checked ~ .vs-switch__circle {
      .right(4);
      left: unset;
      margin-left: unset;
      background: #1FEEAA !important;;

    }

    &__background {
      background: #FFFFFF;
      opacity: 1;
      padding-bottom: 0 !important;
    }
  }


</style>




// WEBPACK FOOTER //
// src/pages/svc/call/requestcalldialog.vue